/* VITALIA PARIS — Fiche « Nuit & fumée » : galerie, variantes, jauge livraison, barre collante. L'ajout au panier reste géré par vitalia.js. */
(function () {
  'use strict';
  function money(cents, currency) {
    var v = (Number(cents) || 0) / 100, d = (Math.round(v * 100) % 100 === 0) ? 0 : 2;
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency || 'EUR', minimumFractionDigits: d, maximumFractionDigits: d }).format(v);
  }
  function init(root) {
    var currency = root.getAttribute('data-currency') || 'EUR';
    var threshold = Number(root.getAttribute('data-threshold')) || 4900;
    var cartTotal = Number(root.getAttribute('data-cart-total')) || 0;
    var stage = root.querySelector('[data-vpn-stage]');
    var main = root.querySelector('.vpn-stage__img');
    var caption = root.querySelector('[data-vpn-caption]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-vpn-thumb]'));
    var form = root.querySelector('[data-vp-product-form]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var qty = root.querySelector('[data-vpn-qty]');
    var atc = root.querySelector('[data-vpn-atc]');
    var stickyAtc = root.querySelector('[data-vpn-sticky-atc]');
    var price = root.querySelector('[data-vpn-price]');
    var stickyPrice = root.querySelector('[data-vpn-sticky-price]');
    var stock = root.querySelector('[data-vpn-stock]');
    var meter = root.querySelector('[data-vpn-meter]');
    var shipMsg = root.querySelector('[data-vpn-ship-msg]');
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-vpn-variants]').textContent); } catch (e) { variants = []; }
    var current = variants.find(function (v) { return idInput && String(v.id) === String(idInput.value); }) || variants[0];

    function show(btn) {
      if (!main || !btn) return;
      var night = btn.getAttribute('data-night') === '1';
      main.removeAttribute('sizes');
      main.srcset = btn.getAttribute('data-srcset') || '';
      main.setAttribute('sizes', '(min-width: 990px) 55vw, 100vw');
      main.src = btn.getAttribute('data-src');
      main.alt = btn.getAttribute('data-alt') || '';
      if (stage) { stage.classList.toggle('is-night', night); stage.classList.toggle('is-day', !night); }
      if (caption && night) caption.textContent = btn.getAttribute('data-caption') || caption.textContent;
      thumbs.forEach(function (t) { t.setAttribute('aria-pressed', t === btn ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t); }); });
    if (stage && thumbs.length > 1) {
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        var i = thumbs.findIndex(function (t) { return t.getAttribute('aria-pressed') === 'true'; });
        var n = (i + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
        show(thumbs[n]);
      }, { passive: true });
    }

    function chosen() {
      var picks = [];
      root.querySelectorAll('[data-vpn-option]').forEach(function (el) {
        var i = Number(el.getAttribute('data-vpn-option'));
        if (el.tagName === 'SELECT') picks[i] = el.value;
        else if (el.checked) picks[i] = el.value;
      });
      return picks;
    }
    function updateShip() {
      if (!current) return;
      var q = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
      var line = current.price * q;
      var total = cartTotal + line;
      var left = threshold - total;
      if (meter) meter.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
      if (shipMsg) shipMsg.textContent = left > 0 ? 'Plus que ' + money(left, currency) + ' pour la livraison offerte.' : 'Livraison offerte sur cette commande.';
      var lineEl = root.querySelector('[data-vpn-line]');
      if (lineEl) lineEl.textContent = money(line, currency);
    }
    function render(fromUser) {
      if (variants.length > 1) {
        var picks = chosen();
        var match = variants.find(function (v) { return v.options.every(function (o, i) { return picks[i] === undefined || String(o) === String(picks[i]); }); });
        current = match || null;
      }
      var ok = !!(current && current.available);
      if (idInput && current) idInput.value = current.id;
      if (price) price.textContent = current ? money(current.price, currency) : '—';
      if (stickyPrice) stickyPrice.textContent = current ? money(current.price, currency) : '—';
      if (stock) stock.textContent = !current ? 'Combinaison indisponible' : (ok ? 'Disponible à la commande' : 'Temporairement indisponible');
      if (qty && current) {
        var capped = current.inventory_management && current.inventory_policy === 'deny' && isFinite(Number(current.inventory_quantity));
        var max = capped ? Math.max(1, Math.min(99, Number(current.inventory_quantity))) : 99;
        qty.max = String(max);
        if (Number(qty.value) > max) qty.value = String(max);
      }
      if (atc) { atc.disabled = !ok; atc.innerHTML = ok ? 'Ajouter au panier — <span data-vpn-line></span>' : 'Indisponible'; }
      if (stickyAtc) { stickyAtc.disabled = !ok; stickyAtc.textContent = ok ? 'Ajouter au panier' : 'Indisponible'; }
      updateShip();
      if (fromUser && current) {
        if (current.featured_media && current.featured_media.id) {
          var t = thumbs.find(function (b) { return b.getAttribute('data-media-id') === String(current.featured_media.id); });
          if (t) show(t);
        }
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', current.id); window.history.replaceState({}, '', u.toString());
        }
      }
    }
    root.querySelectorAll('[data-vpn-option]').forEach(function (el) { el.addEventListener('change', function () { render(true); }); });
    if (qty) qty.addEventListener('change', updateShip);
    if (qty) qty.addEventListener('input', updateShip);
    render(false);

    var sticky = root.querySelector('[data-vpn-sticky]');
    if ('IntersectionObserver' in window) {
      if (sticky && atc) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var on = !e.isIntersecting;
            sticky.classList.toggle('is-visible', on);
            sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
            if (stickyAtc) stickyAtc.tabIndex = on ? 0 : -1;
          });
        }).observe(atc);
      }
      if (stage) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { root.classList.toggle('is-offscreen', !e.isIntersecting); });
        }).observe(stage);
      }
    }
  }
  document.querySelectorAll('[data-vpn]').forEach(init);
}());
